import React from 'react';
import { Table, Input, Loader, Button, Dropdown, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { toastError } from '../../../utils/toastMessage';
import {
  H1,
  StyledLink,
  LinkBlock,
  TableBlock,
  H2,
} from '../CreateProductPage/CreateProductStyles';
import EditIcon from '../../../images/edit_icon.png';
import {
  DeleteButton,
  EditButton,
  Img,
  ButtonBlock,
  ProductNameBlock,
  Label,
  LoaderBlock,
  SortBlock,
  ColumnName,
  FooterBlock,
  ButtonGroupBlock,
  GoToDishList,
} from './ProductsListStyles';
import { product_tags_id, defaultMeasureOfWeightlist } from '../youslim2.0_Constants';
import ProductsTagsBlock from '../TagsBlock/ProductsTagsBlock';
import * as action from '../../../actions/newYouslim';
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';
import debounce from '../../../utils/debounce';
import SortButton from '../SortButton';
import Navbar from '../Navigation/Navbar';
const IconEye = () => <Icon name="eye" />;

const ProductsListPage = React.memo(
  ({
    getProductTags,
    getProductsByName,
    allTags,
    products,
    isSearchProductLoading,
    setCurrentProduct,
    numberOfLinkedRecipes,
    getNumberOfLinkedRecipes,
    deleteProduct,
    setProductToFind,
    isProductLoading,
  }) => {
    const [choosedTags, setChoosedTags] = React.useState([]);
    const [isShowDeletePopup, setIsShowDeletePopup] = React.useState(false);
    const [productCurrentName, setProductCurrentName] = React.useState('');
    const [productCurrentId, setProductCurrentId] = React.useState(0);
    const [productsList, setProductsList] = React.useState([...products]);
    const [tagsSearchRule, setTagsSearchRule] = React.useState(false);
    const [currentMeasureOfWeight, setCurrentMeasureOfWeight] = React.useState('');

    React.useEffect(() => {
      setProductsList([...products]);
    }, [products]);

    React.useEffect(() => {
      getProductTags(product_tags_id);
      getProductsByName();
    }, []);

    const filteringByTags = React.useCallback(
      (choosedTags) => {
        const productsListArray = products;
        const newProductList = [];
        if (!choosedTags.length) return setProductsList([...products]);
        productsListArray.forEach((dish) => {
          if (!tagsSearchRule) {
            let isProductHaveTags = false;
            dish.tags.forEach((tag) => {
              if (choosedTags.indexOf(tag.id) !== -1) {
                isProductHaveTags = true;
              }
            });
            if (isProductHaveTags && newProductList.indexOf(dish) === -1) {
              newProductList.push(dish);
            }
          } else {
            const productTagsIds = [];
            dish.tags.forEach((tag, i) => {
              productTagsIds.push(tag.id);
              if (dish.tags.length - 1 === i) {
                if (choosedTags.every((tag) => productTagsIds.includes(tag))) {
                  newProductList.push(dish);
                }
              }
            });
          }
        });
        setProductsList([...newProductList]);
      },
      [tagsSearchRule, products, setProductsList],
    );

    React.useEffect(() => {
      filteringByTags(choosedTags);
    }, [choosedTags, tagsSearchRule]);

    React.useEffect(() => {
      if (!isProductLoading) {
        setIsShowDeletePopup(false);
      }
    }, [isProductLoading]);

    const confirmDeleting = React.useCallback(
      (name, id) => {
        setProductCurrentName(name);
        setIsShowDeletePopup(true);
        getNumberOfLinkedRecipes(id);
        setProductCurrentId(id);
      },
      [setProductCurrentName, setIsShowDeletePopup, getNumberOfLinkedRecipes, setProductCurrentId],
    );

    const onDeleteProduct = React.useCallback(() => {
      deleteProduct(productCurrentId);
    }, [setIsShowDeletePopup, deleteProduct, productCurrentId]);

    const onSearchProduct = debounce((name) => {
      getProductsByName(name);
    }, 1000);

    const onEditClick = React.useCallback(
      (product) => {
        setCurrentProduct(product);
      },
      [setCurrentProduct],
    );

    const onGoToDishClick = React.useCallback(
      (productId) => {
        setProductToFind([productId]);
      },
      [setCurrentProduct],
    );

    const SortNutrients = React.useCallback(
      (sortArray, isFromMoreToLess, nutrient) => {
        sortArray.sort(function (a, b) {
          return isFromMoreToLess ? b[nutrient] - a[nutrient] : a[nutrient] - b[nutrient];
        });

        setProductsList([...sortArray]);
      },
      [setProductsList],
    );

    const SortByName = React.useCallback(
      (sortArray) => {
        sortArray.sort(function (a, b) {
          if (a && b) {
            if (a.name > b.name) {
              return 1;
            }
            if (a.name < b.name) {
              return -1;
            }
          }
          return 0;
        });

        setProductsList([...sortArray]);
      },
      [setProductsList],
    );

    const ClearSort = React.useCallback(() => {
      setProductsList([...products]);
    }, [setProductsList, products]);

    const filteringByMeasureOfWeight = React.useCallback(
      (measureValue) => {
        setCurrentMeasureOfWeight(measureValue);
        const productsListArray = products;
        const newProductList = [];
        if (measureValue) {
          productsListArray.forEach((product) => {
            if (product.measure === defaultMeasureOfWeightlist[measureValue - 1].text) {
              newProductList.push(product);
            }
          });
        }
        if (newProductList.length) {
          setProductsList([...newProductList]);
        } else {
          setProductsList([...products]);
          toastError('Продуктов с такой мерой веса не существует');
          setCurrentMeasureOfWeight('');
        }
      },
      [setCurrentMeasureOfWeight, products],
    );

    return (
      <React.Fragment>
        <Navbar />
        <H1>Список продуктов</H1>
        <ProductNameBlock>
          <Label>Поиск блюда</Label>
          <Input
            className="product-name-input"
            placeholder="Введите название блюда"
            onChange={(e) => onSearchProduct(e.target.value)}
          />
        </ProductNameBlock>
        <ProductsTagsBlock
          allTags={allTags}
          choosedTags={choosedTags}
          setChoosedTags={setChoosedTags}
          flexBasis="7%"
          height="180px"
        />
        <ButtonGroupBlock>
          <Button.Group>
            <Button
              className={!tagsSearchRule ? 'or_button_active' : 'or_button'}
              active={!tagsSearchRule}
              onClick={() => setTagsSearchRule(false)}
            >
              Искать теги с правилом ИЛИ
            </Button>
            <Button.Or />
            <Button
              className={tagsSearchRule ? 'and_button_active' : 'and_button'}
              active={tagsSearchRule}
              onClick={() => setTagsSearchRule(true)}
            >
              Искать теги с правилом И
            </Button>
          </Button.Group>
        </ButtonGroupBlock>
        <TableBlock>
          {productsList.length ? (
            <Table celled>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>
                    <ButtonBlock>
                      Название Продукта
                      <SortButton
                        onClickSort={SortByName}
                        iconName="sort alphabet down"
                        arrayForSort={productsList}
                      />
                    </ButtonBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>Калорийность</ColumnName>
                      <ButtonBlock>
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess={false}
                          nutrient="calories"
                          iconName="sort numeric down"
                          arrayForSort={productsList}
                        />
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess
                          nutrient="calories"
                          iconName="sort numeric up"
                          arrayForSort={productsList}
                        />
                      </ButtonBlock>
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>
                        Животный <br /> белок
                      </ColumnName>
                      <ButtonBlock>
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess={false}
                          nutrient="animal_protein"
                          iconName="sort numeric down"
                          arrayForSort={productsList}
                        />
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess
                          nutrient="animal_protein"
                          iconName="sort numeric up"
                          arrayForSort={productsList}
                        />
                      </ButtonBlock>
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>
                        Pастительный <br /> белок
                      </ColumnName>
                      <ButtonBlock>
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess={false}
                          nutrient="vegetable_protein"
                          iconName="sort numeric down"
                          arrayForSort={productsList}
                        />
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess
                          nutrient="vegetable_protein"
                          iconName="sort numeric up"
                          arrayForSort={productsList}
                        />
                      </ButtonBlock>
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>
                        Насыщенные
                        <br /> жиры
                      </ColumnName>
                      <ButtonBlock>
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess={false}
                          nutrient="saturated_fat"
                          iconName="sort numeric down"
                          arrayForSort={productsList}
                        />
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess
                          nutrient="saturated_fat"
                          iconName="sort numeric up"
                          arrayForSort={productsList}
                        />
                      </ButtonBlock>
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>
                        Ненасыщенные
                        <br /> жиры
                      </ColumnName>
                      <ButtonBlock>
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess={false}
                          nutrient="unsaturated_fats"
                          iconName="sort numeric down"
                          arrayForSort={productsList}
                        />
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess
                          nutrient="unsaturated_fats"
                          iconName="sort numeric up"
                          arrayForSort={productsList}
                        />
                      </ButtonBlock>
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>
                        Простые <br /> углеводы
                      </ColumnName>
                      <ButtonBlock>
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess={false}
                          nutrient="simple_carbohydrates"
                          iconName="sort numeric down"
                          arrayForSort={productsList}
                        />
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess
                          nutrient="simple_carbohydrates"
                          iconName="sort numeric up"
                          arrayForSort={productsList}
                        />
                      </ButtonBlock>
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>
                        Сложные
                        <br /> углеводы
                      </ColumnName>
                      <ButtonBlock>
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess={false}
                          nutrient="complex_carbohydrates"
                          iconName="sort numeric down"
                          arrayForSort={productsList}
                        />
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess
                          nutrient="complex_carbohydrates"
                          iconName="sort numeric up"
                          arrayForSort={productsList}
                        />
                      </ButtonBlock>
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <SortBlock>
                      <ColumnName>Клетчатка</ColumnName>
                      <ButtonBlock>
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess={false}
                          nutrient="cellulose"
                          iconName="sort numeric down"
                          arrayForSort={productsList}
                        />
                        <SortButton
                          onClickSort={SortNutrients}
                          isFromMoreToLess
                          nutrient="cellulose"
                          iconName="sort numeric up"
                          arrayForSort={productsList}
                        />
                      </ButtonBlock>
                    </SortBlock>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <ColumnName>Мера веса</ColumnName>
                    <Dropdown
                      placeholder="Мера"
                      fluid
                      search
                      selection
                      clearable
                      options={defaultMeasureOfWeightlist}
                      value={currentMeasureOfWeight}
                      onChange={(e, data) => filteringByMeasureOfWeight(data.value)}
                    />
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <ColumnName>Теги</ColumnName>
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing>
                    <Button size="mini" onClick={() => ClearSort()}>
                      Сбросить <br /> сортировку
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {productsList.map((product) => (
                  <Table.Row key={product && product.id}>
                    <Table.Cell>{product && product.name}</Table.Cell>
                    <Table.Cell>{product && product.calories}</Table.Cell>
                    <Table.Cell className="protein_cell">
                      {product && product.animal_protein}
                    </Table.Cell>
                    <Table.Cell className="protein_cell">
                      {product && product.vegetable_protein}
                    </Table.Cell>
                    <Table.Cell className="fat_cell">{product && product.saturated_fat}</Table.Cell>
                    <Table.Cell className="fat_cell">
                      {product && product.unsaturated_fats}
                    </Table.Cell>
                    <Table.Cell className="arbohydrates_cell">
                      {product && product.simple_carbohydrates}
                    </Table.Cell>
                    <Table.Cell className="arbohydrates_cell">
                      {product && product.complex_carbohydrates}
                    </Table.Cell>
                    <Table.Cell>{product && product.cellulose}</Table.Cell>
                    <Table.Cell>{product && product.measure}</Table.Cell>
                    <Table.Cell className="product_tags_block">
                      {product && product.tags.length && (
                        <div
                          className="product_tags"
                          data-title={product.tags.map((tag) => {
                            return ` ${tag.name}`;
                          })}
                        >
                          {product.tags[0].name}
                        </div>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      <ButtonBlock>
                        <EditButton
                          onClick={() => onEditClick(product)}
                          to={`/youslim2.0/product/${product.id}/edit`}
                          target="_blank"
                        >
                          <Img src={EditIcon} alt="edit" />
                        </EditButton>
                        <DeleteButton onClick={() => confirmDeleting(product.name, product.id)}>
                          x
                        </DeleteButton>
                        <GoToDishList
                          to="/youslim2.0/dishList"
                          onClick={() => onGoToDishClick(product.id)}
                        >
                          <IconEye />
                        </GoToDishList>
                      </ButtonBlock>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          ) : (
            <LoaderBlock>
              {isSearchProductLoading ? (
                <Loader active={isSearchProductLoading} inline="centered" />
              ) : (
                <H2>Продукт с подходящим именем не найден</H2>
              )}
            </LoaderBlock>
          )}
        </TableBlock>
        <FooterBlock />

        <DeleteConfirmPopup
          isOpen={isShowDeletePopup}
          title={productCurrentName}
          isLoadingDelete={isProductLoading}
          onCancel={() => setIsShowDeletePopup(false)}
          onDelete={onDeleteProduct}
          numberOfLinkedRecipes={numberOfLinkedRecipes}
          warning={`Внимание! Данный продукт будет удалён из всех связанных рецептов ${numberOfLinkedRecipes}, нутриенты в рецептах будут пересчитаны!`}
        />
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const {
    allTags,
    products,
    isSearchProductLoading,
    numberOfLinkedRecipes,
    isProductLoading,
  } = state.newYouslim;
  return {
    allTags,
    products,
    isSearchProductLoading,
    numberOfLinkedRecipes,
    isProductLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProductTags: (tags) => {
      dispatch(action.getProductTags(tags));
    },
    createProduct: (data, clear) => {
      dispatch(action.createProduct(data, clear));
    },
    getProductsByName: (name, tags) => {
      dispatch(action.getProductsByName(name, tags));
    },
    setCurrentProduct: (product) => {
      dispatch(action.setCurrentProduct(product));
    },
    getNumberOfLinkedRecipes: (id) => {
      dispatch(action.getNumberOfLinkedRecipes(id));
    },
    deleteProduct: (id) => {
      dispatch(action.deleteProduct(id));
    },
    setProductToFind: (id) => {
      dispatch(action.setProductToFind(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsListPage);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/ProductsListPage/index.jsx